import { userService } from "../services";
import config from "../config/config";
import {
  decryptAesObj,
  decryptAesObjNew,
} from "../components/CommonComponents/AESencryptdecrypt";
export const VehicleAction = {
  deleteVehicles,
  gettingExistingVehicleAccess,
  addVehicleForAccess,
  fetchVehicleListForVehicleAddModal,
  fetchVehicleList,
  saveUser,
  fetchById,
  userActiveInactive,
  updateUser,
  vehicleTypeList,
  VehicleRefresh,
  etpOrderFetch,
  VehicleGpsRemove,
  vehicleMaintanceList,
  addOrUpdateMaintance,
  addConstituency,
  updateDistance,
  updateVehicleIsDesignated,
  checkIsDisengased,
  vehicleReplace,
  fetchAddWorkOrderVehicle,
  disengageGps,
  fetchTrailsVhecle,
  fetchVehicleListLite,
};

async function updateDistance(payload, reset) {
  console.log(payload);
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.UpdateDistance}`;
    let response = await userService.updateDistance(
      apiEndpoint,
      payload,
      reset
    );
    console.log("update response", response);
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchVehicleList(payload) {
  console.log("fetchVehicleListpayload", payload);
  // debugger
  try {
    let data = {
      company: {
        id: payload.companyId,
      },
      number: payload.number,
      tankerManagement: payload?.isTankerManagement ? true : false,
      vehicleType: {
        id: payload.vehicleType,
      },
      driver: {
        name: payload.driver || "",
      },
      site: {
        id: payload.siteId,
      },
      wardId: payload.wardId,
      vendorId: payload.vendorId
        ? payload.vendorId
        : decryptAesObj(localStorage.getItem("data")).userType == "VENDOR"
          ? decryptAesObj(localStorage.getItem("data")).vendorUserId &&
          decryptAesObj(localStorage.getItem("data")).vendorUserId
          : "",
      siteIds: payload.siteIds,
      userId: payload.userId,
      isDisengased: payload?.isDisengased,
      vehicleIds: payload.vehicleIds,
      onlyGpsVehicle: payload.onlyGpsVehicle,
      allVehicle: payload.allVehicle,
      fuelSensorEnabled: payload.fuelSensorEnabled,
      vehicleMaintenanceCategory: payload.vehicleMaintenanceCategory,
      forDropDown: payload.forDropDown ? true : false,
      tankerType: payload.tankerType ? payload.tankerType : null,
      isScheduleVehicle: payload.isScheduleVehicle
        ? payload.isScheduleVehicle
        : null,
      l89: payload?.l89 ? payload?.l89 : false,
      filterType: payload?.filterType === "MONTHLY" ? "THIS_MONTH" : payload?.filterType ? payload?.filterType : null,
    };
    if (payload.hasOwnProperty("workOrder")) {
      data["isWorkorderVehicle"] = true;
    }
    if (payload.hasOwnProperty("noWorkOrder")) {
      data["isWorkorderVehicle"] = false;
    }
    if (payload.hasOwnProperty("scheduleVehicleForMonth")) {
      data["isScheduleVehicleForMonth"] = true;
    }
    if (payload.hasOwnProperty("noScheduleVehicleForMonth")) {
      data["isScheduleVehicleForMonth"] = false;
    }
    if (payload.hasOwnProperty("gpsActive")) {
      data["active"] = true;
    }
    if (payload.hasOwnProperty("noGpsActive")) {
      data["active"] = false;
    }
    if (payload.hasOwnProperty("vehiclehavingscheduled")) {
      data["havingScheduleButNotInWOFilter"] = true;
    }
    if (payload.hasOwnProperty("vehiclehavingtrip")) {
      data["havingFPLTripButNotInWOFilter"] = true;
    }
    if (payload.hasOwnProperty("MS_HIRED_WO")) {
      data["isWorkorderVehicle"] = true;
    }

    let apiEndpoint = `${config.baseUrl}${config.apiName.VehicleList}?pageSize=${payload.pageSize}&pageNo=${payload.pageNo}`;

    console.log("payvehicleDeaitleload", data);

    let response = await userService.post(apiEndpoint, data);
    console.log("response-1", response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      // console.log(decryptAesObj(response.data));

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchVehicleListLite(payload) {
  let apiEndpoint = `${config.baseUrl}${config.apiName.VehicleListLite}`;
  try {

    let response = await userService.get(apiEndpoint);
    console.log("response-1", response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      // console.log(decryptAesObj(response.data));

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}


// /api/v2/vehicle/all/lite

async function updateUser(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.UpdateVehicle}`;
    let response = await userService.postFIle(apiEndpoint, payload);
    if ((response && response.status == 200) || response.status == 201) {
      return response?.data;
    } else {
      alert(response?.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function addConstituency(payload) {
  console.log(payload);
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.addconstituencyInVehicle}`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if ((response && response.status == 200) || response.status == 201) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function saveUser(payload) {
  // return false
  try {
    debugger;
    let apiEndpoint = `${config.baseUrl}${config.apiName.AddVehicle}`;
    debugger;
    let response = await userService.postFIle(apiEndpoint, payload);
    // let response = await userService.newPostFIle(apiEndpoint, payload);
    debugger;
    if (response && response?.status == 201) {
      return response;
    } else {
      alert(response?.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function userActiveInactive(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.ActiveVehicle}`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);
      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function addOrUpdateMaintance(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.maintenanceAdd}`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if ((response && response.status == 200) || response.status == 201) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchAddWorkOrderVehicle(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.addWorkOderVehicle}`;

    let response = await userService.postFIle(apiEndpoint, payload);
    console.log(response);
    if ((response && response.status == 200) || response.status == 201) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function disengageGps(payload) {
  try {
    const companyId = payload.get("companyId");

    let apiEndpoint = `${config.baseUrl}${config.apiName.disengageGps}?companyId=${companyId}`;

    let response = await userService.postFIle(apiEndpoint, payload);
    console.log(response);
    if ((response && response.status == 200) || response.status == 201) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchById(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.VehicleById}?id=${payload.userId}&companyId=${payload.companyId}`;
    // let apiEndpoint = `${config.baseUrlSubham}${config.apiName.VehicleById}?id=${payload.userId}&companyId=${payload.companyId}`;

    let response = await userService.get(apiEndpoint);
    // let response = await userService.newGet(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function vehicleTypeList(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.VehicleTypeList}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function vehicleMaintanceList(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.maintenanceVehicleList}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
async function fetchTrailsVhecle(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.vehicleReplacmentTrail}?vehicleId=${payload?.vehicleId}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function VehicleRefresh(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.SyncVehicle}?vehicleNo=${payload.vehicleNo}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function VehicleGpsRemove(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.removeGpsFromVehicle}?companyId=${payload.companyId}&id=${payload.vehicleId}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function etpOrderFetch(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.EtpOrder}?orderId=${payload.orderId}&companyId=${payload.companyId}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchVehicleListForVehicleAddModal(payload) {
  try {
    const apiEndpoint = config.baseUrl + config.apiName.VehicleList;
    const response = await userService.post(apiEndpoint, payload);

    console.log("response.data34534", response.data);

    console.log(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function addVehicleForAccess(payload) {
  try {
    const apiEndpoint = config.baseUrl + config.apiName.vehicleAddForAccess;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 201) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function gettingExistingVehicleAccess(payload) {
  try {
    const apiEndpoint = config.baseUrl + config.apiName.existingVehicleAccess;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function deleteVehicles(payload) {
  try {
    const apiEndpoint = config.baseUrl + config.apiName.deleteVehicles;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 201) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}
async function updateVehicleIsDesignated(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.vehicleUpdateIsDesignated}?companyId=${payload.companyId}&id=${payload.id}&userName=${payload.userName}&remark=${payload.remark}`;
    const response = await userService.GetWithoutEncrypt(apiEndpoint);
    if (response && response.status === 200) {
      // Assuming a successful response has status 200
      return response.data; // Return the response data
    } else {
      return null; // Return null if the response status is not 200
    }
  } catch (err) {
    console.error("Error in updateVehicleIsDesignated:", err); // Log any errors for debugging
    return null; // Return null if an error occurs
  }
}

async function checkIsDisengased(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.isDisengased}?pageNo=${payload.pageNo}&pageSize=${payload.pageSize}`;
    debugger;
    let data = {
      company: {
        id: payload.companyId,
      },
      number: payload.number,
      vehicleType: {
        id: payload.vehicleType,
      },
      // driver: {
      //   name: payload.driver,
      // },
      site: {
        id: payload.siteId,
      },
      // vendorId: payload.vendorId
      //   ? payload.vendorId
      //   : decryptAesObj(localStorage.getItem("data")).userType == "VENDOR"
      //   ? decryptAesObj(localStorage.getItem("data")).vendorUserId &&
      //     decryptAesObj(localStorage.getItem("data")).vendorUserId
      //   : "",
      siteIds: payload.siteIds,
      userId: payload.userId,
      vehicleIds: payload.vehicleIds,
      // onlyGpsVehicle: payload.onlyGpsVehicle,
      // allVehicle: payload.allVehicle,
      // fuelSensorEnabled: payload.fuelSensorEnabled,
      // vehicleMaintenanceCategory: payload.vehicleMaintenanceCategory,
      forDropDown: payload.forDropDown ? true : false,
      tankerType: payload.tankerType ? payload.tankerType : null,
    };
    let response = await userService.post(apiEndpoint, data);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      // alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function vehicleReplace(fromData) {
  try {
    const payload = {
      id: fromData.selectedVehicle,
      replacedIn: fromData.validateDate,
      remark: fromData.remark,
      replacedVehicleId: fromData.vehicleId.id,
    };

    let apiEndpoint = `${config.baseUrl}${config.apiName.vehicleReplace}`;
    let response = await userService.post(apiEndpoint, payload);

    // let apiEndpoint = `${config.localBaseUrl}${config.apiName.vehicleReplace}`;
    // let response = await userService.post(apiEndpoint, payload);

    if (response && response.status == 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
